'use client'
import Image from 'next/image'
import Link from 'next/link'
import { useParams, useRouter, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

interface Category {
    label: string,
    image: string,
    value: string,
    slug: string,
    exclusive?: boolean
    key:string
}


export default function SidebarProduct({ items }: { items: Category[] }) {
    const params = useParams()
    const searchParams = useSearchParams()
    const router = useRouter()
    useEffect(() => {
        if (!searchParams.get('id') && items.length > 0) {
            router.push(`/items/${params?.item_category}/${items[0].slug}?id=${items[0].value}&key=${items[0].key}`);
        }else if(searchParams.get('id') && items.length > 0){
            let exists = items.find(i=>i.value===searchParams.get('id'))
            if(exists){
                router.push(`/items/${params?.item_category}/${exists.slug}?id=${exists.value}&key=${exists.key}`);
            }
        }
    }, [ items]);

    return (
        <aside className="w-20 bg-white border-r flex flex-col items-center pb-[100px] gap-2 h-full overflow-y-auto">
            {items.map((cat) => (
                <Link href={`/items/${params?.item_category}/${cat?.slug}?id=${cat.value}&key=${cat.key}`} key={cat.value} className='w-full mb-2 relative'>
                    {/* {searchParams.get('id') === cat.value && <div className="border-l-4 border-[#2563eb] absolute inset-y-0 left-0 w-1.5"></div>} */}
                    <div
                        key={cat.value}
                        className={`flex flex-col items-center w-full py-2 cursor-pointer }`}
                    >
                        <figure className="relative mb-1">
                            {searchParams.get('id') === cat.value && (
                                <div 
                                    className="absolute inset-0 rounded-[12px] p-[1.5px]"
                                    style={{
                                        background: 'radial-gradient(227.4% 85.83% at 92.5% 14.17%, #FFFFFF 0%, #FFF1E6 57.78%, #6D401A 100%)'
                                    }}
                                >
                                    <div className="w-full h-full rounded-[10.5px]" style={{
                                        background: 'linear-gradient(360deg, #F8DCC4 0%, #FFFFFF 100%)'
                                    }} />
                                </div>
                            )}
                            <div className="relative z-1 p-1">
                                <Image
                                    src={cat.image?`${cat.image}?h=100` : process.env.NEXT_PUBLIC_UNKONWN_CATEGORIES?process.env.NEXT_PUBLIC_UNKONWN_CATEGORIES:""}
                                    alt={cat.label}
                                    width={40}
                                    height={40}
                                    className="rounded-[12px] transition-all h-[40px] w-[40px] object-cover"
                                />
                            </div>
                        </figure>
                        <span
                            className={`text-xs text-center px-1 ${searchParams.get('id') === cat.value ? 'text-[#6F421D] font-semibold' : 'text-gray-500'
                                }`}
                        >
                            {cat.label.length > 14
                                ? cat.label.slice(0, 13) + '…'
                                : cat.label}
                        </span>
                    </div>
                </Link>
            ))}
        </aside>
    )
}